import { Typography, Grid2 as Grid, Skeleton, Box } from "@mui/material";
import { Address } from "./Address";
import { OrganizationInfo, AccountInfo } from "../../../types";

type Props = {
  organizationInfo?: OrganizationInfo;
  accountInfo?: AccountInfo;
  isLoading: boolean;
};

export const AccountDetails = ({
  organizationInfo,
  accountInfo,
  isLoading,
}: Props) => {
  return (
    <Grid
      size={12}
      gap={2}
      container
      sx={{
        boxShadow: "0px 0px 4px 0px #00000040",
        borderRadius: "4px",
        backgroundColor: "white",
        p: 2,
      }}
    >
      <Grid size={12}>
        {isLoading ? (
          <Skeleton variant="rectangular" sx={{ height: 32, width: "20%" }} />
        ) : (
          <Typography component="div" variant="h5">
            {organizationInfo?.name || ""}
          </Typography>
        )}
      </Grid>

      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          justifyContent: "space-between",
          width: "100%",
          gap: 2,
        }}
      >
        <Box
          sx={{
            display: "flex",
            gap: { xs: 2, md: 12 },
            flexDirection: { xs: "column", md: "row" },
            minWidth: "30%",
          }}
        >
          <Address
            title="From"
            addressLines={[organizationInfo?.name || ""]}
            contactNumber={organizationInfo?.contactNumber || ""}
            email={organizationInfo?.primaryAddress?.email || ""}
            isLoading={isLoading}
          />
          <Address
            title="To"
            addressLines={[
              accountInfo?.baseInfo.accountName || "",
              accountInfo?.baseInfo.accountAddress.addressLine1 || "",
              accountInfo?.baseInfo.accountAddress.addressLine2 || "",
              `${accountInfo?.baseInfo.accountAddress.city}, ${accountInfo?.baseInfo.accountAddress.state} ${accountInfo?.baseInfo.accountAddress.zip}`,
              `${accountInfo?.baseInfo.accountAddress.country === "CA" ? "Canada" : ""}`,
            ].filter(Boolean)}
            contactNumber={accountInfo?.baseInfo.contactNumber || ""}
            email={accountInfo?.baseInfo.accountAddress.email || ""}
            isLoading={isLoading}
          />
        </Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: { xs: "flex-start", md: "flex-end" },
            minWidth: "15%",
          }}
        >
          <Address
            title={"Remittance Address"}
            addressLines={[
              organizationInfo?.remittanceAddress?.addressLine1 || "",
              organizationInfo?.remittanceAddress?.addressLine2 || "",
              `${organizationInfo?.remittanceAddress?.city}, ${organizationInfo?.remittanceAddress?.state} ${organizationInfo?.remittanceAddress?.zip}`,
              `${organizationInfo?.remittanceAddress?.country === "CA" ? "Canada" : ""}`,
            ].filter(Boolean)}
            isLoading={isLoading}
          />
        </Box>
      </Box>
    </Grid>
  );
};
